var map = {
	"./agility.png": "0865",
	"./attack.png": "5e27",
	"./construction.png": "098d",
	"./cooking.png": "54fa",
	"./crafting.png": "cb10",
	"./defence.png": "caf7",
	"./farming.png": "1f55",
	"./firemaking.png": "dddb",
	"./fishing.png": "3d98",
	"./fletching.png": "b9d5",
	"./herblore.png": "144c",
	"./hitpoints.png": "eeba",
	"./hunter.png": "cf92",
	"./magic.png": "9b68",
	"./mining.png": "0ef3",
	"./overall.png": "bff2",
	"./prayer.png": "56d3",
	"./ranged.png": "0505",
	"./runecrafting.png": "6cc5",
	"./slayer.png": "4268",
	"./smithing.png": "db8f",
	"./strength.png": "c392",
	"./thieving.png": "1e5f",
	"./woodcutting.png": "f707"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80fa";